import { ModelIndexPage } from '@rhino-project/ui-heroui';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/$owner/activity/')({
  component: RouteComponent
});

function RouteComponent() {
  return <ModelIndexPage model="event" syncUrl />;
}
